import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { OkrProgress } from 'screens/Team/Rabbit/Goals/AgGridTreeView/components/CommonTreeCell/ObjectiveProgressCell';
import { getMeasureUnitDetails } from 'screens/common/sidepanel/Goals/GoalProgress';
import { useReviewFormSidebarDataOld } from 'screens/performanceReview/components/Sidebar/hooks/dataHooks';
import useReviewFormParams from 'screens/performanceReview/hooks/useReviewFormParams';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const TopBottomLabelValue = ({ label, value }) => (
  <Flex flexDir="column">
    <TextLabel color="text.g2" bold mb={1}>
      {label}
    </TextLabel>
    <TextBodyMedium bold>{value}</TextBodyMedium>
  </Flex>
);

const getAchievedValue = ({ orgCurrency = null, achieved, unit }) => {
  const { symbol: unitSymbol, isPrefix } = getMeasureUnitDetails(unit, orgCurrency ?? 'INR');

  if (isPrefix) {
    return `${unitSymbol} ${achieved}`;
  }
  return `${achieved} ${unitSymbol}`;
};

const ReviewResultGoalSummary = ({ okr = {}, ...containerProps }) => {
  const isObjectiveType = okr?.type === 'OBJECTIVE';
  const { employeeId, providerId, reviewId } = useReviewFormParams();
  const employeeObj = useSelector(selectLoggedInEmployeeData);
  const orgCurrency = employeeObj?.organization?.currency ?? null;

  const { data: formData } = useReviewFormSidebarDataOld({
    employeeId,
    providerId,
    reviewId,
  });

  const { isShowGoalWeightage } = formData ?? {};

  let weightageText = '-';
  if (okr?.weightage > 0) {
    weightageText = `${okr.weightage}%`;
  }

  if (isEmpty(okr)) {
    return null;
  }

  return (
    <Box {...containerProps}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        {isObjectiveType && (
          <Flex justifyContent="space-between" alignItems="center" mb={4}>
            <Flex sx={{ width: '20rem' }} my={4} flexDir="column" mr="32px">
              <TextLabel color="text.g2" bold mb={2}>
                Progress
              </TextLabel>
              <OkrProgress data={okr} />
            </Flex>
            <TopBottomLabelValue label="Weightage" value={weightageText} />
          </Flex>
        )}

        {!isObjectiveType && (
          <>
            <Flex sx={{ width: '20rem' }} flexDir="column">
              <TextLabel color="text.g2" bold mb={1}>
                Progress
              </TextLabel>
              <OkrProgress data={okr} />
            </Flex>
            {isShowGoalWeightage && <TopBottomLabelValue label="Weightage" value={weightageText} />}
            <TopBottomLabelValue label="Target" value={okr?.target || '-'} />
            <TopBottomLabelValue
              label="Achieved"
              value={getAchievedValue({ orgCurrency, achieved: okr?.achieved, unit: okr?.metric })}
            />
          </>
        )}
      </Flex>
      {okr?.description && (
        <>
          <TextLabel color="text.g2" bold mb={1}>
            Description
          </TextLabel>
          <TextBodyMedium>{okr?.description ?? '-'}</TextBodyMedium>
        </>
      )}
    </Box>
  );
};

export default ReviewResultGoalSummary;
